import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useUsersData } from "./Helpers/UsersContext";

const AdminProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const auth = getAuth();
    const location = useLocation();
    const { users, loadingUsers } = useUsersData();
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsAuthenticated(!!user);
        });

        return () => unsubscribe();
    }, [auth]);

    // Check admin status when user and users data are available
    useEffect(() => {
        if (auth.currentUser && users && !loadingUsers) {
            const currentUser = users.find(u => u.key === auth.currentUser?.uid);
            setIsAdmin(currentUser?.admin || false);
            setLoading(false);
        }
    }, [auth.currentUser, users, loadingUsers]);

    if (loading || loadingUsers) {
        return <></>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/signIn" state={{ from: location }} replace />;
    }

    if (!isAdmin) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default AdminProtectedRoute;
